module.exports = __webpack_public_path__ + "static/media/29EUNOG3.98ddc2b9.jpg";